// FlowBerry Mock Data
// Used for development and demo purposes

export const mockReviews = [
  {
    id: 1,
    name: 'Sarah M.',
    rating: 5,
    text: 'Absolutely stunning roses! The arrangement was even more beautiful than the photos. Perfect for our anniversary.',
    date: '2 weeks ago',
  },
  {
    id: 2,
    name: 'Michael R.',
    rating: 5,
    text: 'Fast WhatsApp response and the bouquet arrived exactly when promised. My girlfriend loved it!',
    date: '1 month ago',
  },
  {
    id: 3,
    name: 'Jennifer L.',
    rating: 5,
    text: 'The premium wrap made it feel so luxurious. FlowBerry is my go-to for all special occasions now.',
    date: '3 weeks ago',
  },
  {
    id: 4,
    name: 'David K.',
    rating: 5,
    text: 'Ordered last minute for my mom\'s birthday and they made it happen. Quality roses and excellent service.',
    date: '1 week ago',
  },
];

export const mockFAQ = [
  {
    question: 'What areas do you deliver to?',
    answer: 'We deliver across Los Angeles and LA County. Our base is in Glendale, and delivery starts from $10 depending on your location.',
  },
  {
    question: 'How do I place an order?',
    answer: 'Use our bouquet builder to customize your roses, then send your order directly via WhatsApp. We\'ll confirm details and payment with you personally.',
  },
  {
    question: 'What payment methods do you accept?',
    answer: 'We accept Zelle and Apple Cash. Payment details are confirmed via WhatsApp for convenience and security.',
  },
  {
    question: 'Can I pick up my order instead of delivery?',
    answer: 'Yes! We offer free pickup from our Glendale location. Just select "Pickup" when building your bouquet.',
  },
  {
    question: 'How fresh are the roses?',
    answer: 'All our roses are freshly arranged for each order. We source premium roses to ensure maximum freshness and longevity.',
  },
  {
    question: 'What\'s included with my order?',
    answer: 'Every bouquet includes standard wrapping and a complimentary gift note. Premium wrap is available for an additional $20.',
  },
  {
    question: 'How far in advance should I order?',
    answer: 'We recommend ordering at least 24 hours in advance. For same-day orders, please contact us via WhatsApp to check availability.',
  },
  {
    question: 'Can I customize the quantity of roses?',
    answer: 'Yes! Our bouquets come in increments of 25 stems (25, 50, 75, 100, etc.). Choose the perfect size for your occasion.',
  },
  {
    question: 'What if I\'m not satisfied with my order?',
    answer: 'Your satisfaction is our priority. If there\'s any issue with your order, contact us immediately via WhatsApp and we\'ll make it right.',
  },
  {
    question: 'Do you offer same-day delivery?',
    answer: 'Same-day delivery may be available depending on order time and our schedule. Contact us via WhatsApp to check availability.',
  },
];

export const mockGalleryImages = [
  {
    id: 1,
    title: 'Bouquets',
    imagePath: '/images/our-work-bouquet-1.png',
    alt: 'Luxury hand-tied rose bouquet',
  },
  {
    id: 2,
    title: 'Arrangements',
    imagePath: '/images/our-work-arrangement-1.png',
    alt: 'Premium floral arrangement with soft roses',
  },
  {
    id: 3,
    title: 'Flower Boxes',
    imagePath: '/images/our-work-flower-box-1.png',
    alt: 'Elegant flower box filled with roses',
  },
  {
    id: 4,
    title: 'Weddings',
    imagePath: '/images/our-work-wedding-1.png',
    alt: 'Romantic wedding floral design',
  },
  {
    id: 5,
    title: 'Luxury Roses',
    imagePath: '/images/our-work-luxury-roses-1.png',
    alt: 'Luxury rose bouquet with soft floral styling',
  },
  {
    id: 6,
    title: 'Premium Florals',
    imagePath: '/images/our-work-premium-florals-1.png',
    alt: 'Premium floral bouquet arrangement',
  },
];

export const occasions = [
  { id: 1, name: 'Birthday', icon: 'cake' },
  { id: 2, name: 'Anniversary', icon: 'heart' },
  { id: 3, name: 'Date Night', icon: 'sparkles' },
  { id: 4, name: 'Apology', icon: 'handshake' },
  { id: 5, name: 'Just Because', icon: 'gift' },
];

export const trustItems = [
  'Freshly arranged',
  'Gift note included',
  'Premium wrapping',
  'Fast WhatsApp response',
  'Delivery across LA (from $10)',
];

export const businessInfo = {
  name: 'FlowBerry',
  tagline: 'Premium Roses Delivery in Los Angeles',
  location: 'Glendale, California',
  serviceArea: 'Los Angeles / LA County',
  whatsappNumber: '+16097222615',
  whatsappLink: 'https://wa.me/16097222615',
  instagramUrl: 'https://www.instagram.com/flowberry_los?igsh=MTAyZngwbWZwcHRzbg%3D%3D&utm_source=qr',
  workingHours: 'Monday–Sunday, 9:00 AM – 10:00 PM',
  email: null,
};

export default {
  mockReviews,
  mockFAQ,
  mockGalleryImages,
  occasions,
  trustItems,
  businessInfo,
};
